import config from "../../app.json";
import axios from "axios";

import "./managesubscriptionconfig.scss";

import { Context } from "../../Reducers/Store";
import React, { useEffect, useState, useContext } from "react";
import { Button } from "react-bootstrap";
import AlertComponent from "../AlertComponent";
import { numberHasDecimal } from "../../helper";
import moment from "moment";
import EditBilling from "../EditBilling/EditBilling";
import { useNavigate, useLocation } from "react-router-dom";

function ManageSubscriptionConfig(props) {
  const [state, dispatch] = useContext(Context);
  let navigate = useNavigate();

  const [billingData, setBillingData] = useState({ nextBillingAmount: "0", nextBillingDate: "..." });
  const [showEditingBilling, setShowEditingBilling] = useState(false);
  useEffect(() => {
    axios
      .get(config.API_HM + "/subscriptions/billing")
      .then((result) => {
        setBillingData(result.data);
      })
      .catch((error) => {
        AlertComponent("Error", error.Message ?? "Something went wrong. Try again later.", { icon: `error` });
      });
  }, [0]);

  const handleEditBilling = () => {
    setShowEditingBilling(true);
  };

  const handleSubscription = () => {
    dispatch({ type: "SET_CONFIG", payload: false });
    navigate("/selectplan", { replace: false });
  }

  const fetchProfile = () => {
    dispatch({ type: "SET_LOADING", payload: true });

    axios.get(config.API_HM + "/profile").then((result) => {
      dispatch([{ type: "SET_CONFIG", payload: false }, { type: "SET_PROFILE", payload: result.data }]);
      navigate("/selectplan", { replace: false });

    }).catch((error) => {
      AlertComponent("Error", error.message ?? "Something went wrong. Profile could not be loaded. Code: 4", { icon: `error` });
    })
    .finally(() => {
      dispatch({ type: "SET_LOADING", payload: false });
    });
  }

  const handleCancelSubscription = () => {
    AlertComponent(
      "Cancel Subscription",
      "Do you confirm the cancellation of the subscription?",
      {
        icon: `question`,
        showCancelButton: true,
      },
      () => {
        axios.delete(config.API_HM + "/subscriptions").then(() => {
          AlertComponent("Success", "Your subscription was successfully canceled");
          fetchProfile();
        }).catch((error) => {
          AlertComponent("Error", error.Message ?? "Something went wrong. Try again later.", { icon: `error` });
        });
      },
      false,
      "Yes"
    );
  };

  const formatDate = (dateString) => {
    const formattedDate = moment.utc(dateString).tz(moment.tz.guess()).format("MMM Do, YYYY");
    return formattedDate;
  };

  const renderPrice = numberHasDecimal(billingData.nextBillingAmount);

  return (
    <div className="manage-subscription-config-container">
      {!showEditingBilling && (
        <div className="manage-subscription-config-row-reverse">
          <div className="manage-subscription-config-column">
            {/* {currentProfile?.subscription?.plan === "Business" && <Button>Save Changes</Button>} */}

            {/* <div className="manage-subscription-config-add-seats">
            <div className="manage-subscription-config-column">
              <span className="manage-subscription-config-flex manage-subscription-config-add-seats-text">Enterprise</span>
              <span className="manage-subscription-config-flex">+ (5) Seats</span>
            </div>
            <div className="manage-subscription-config-column">
              <Button className="manage-subscription-config-add-seats-button" onClick={handleAddSeats}>
                Add Seats
              </Button>
            </div>
          </div> */}
            <span className="manage-subscription-config-row-reverse manage-subscription-config-billing">Next Billing Cycle: ${renderPrice}</span>
            <span className="manage-subscription-config-next-billing-cycle">Next billing cycle: {formatDate(billingData.nextBillingDate)}</span>
            <div className="manage-subscription-config-buttons">
              <div className="line-buttons">
                <Button className="manage-subscription-config-edit-billing" onClick={handleEditBilling}>
                  Edit Billing
                </Button>
                <Button className="manage-subscription-config-change-plan" onClick={handleSubscription}>
                  Change Plan
                </Button>
              </div>
              
              <Button onClick={handleCancelSubscription} className="manage-subscription-config-cancel-subscription">
                Cancel Subscription
              </Button>
            </div>
          </div>
        </div>
      )}
      {showEditingBilling && <EditBilling setShowEditingBilling={setShowEditingBilling} />}
    </div>
  );
}

export default ManageSubscriptionConfig;
